export default __webpack_public_path__ + "static/media/kit_5.8004737e.png";